import React from 'react'
import { Link } from 'react-router-dom'
import MoreButton from '../components/MoreButton'

const EmptyState = () => (
  <div className="o-width-limiter mb-96 mt-48 text-center lg:mb-128 lg:mt-80 lg:pb-64">
    <p className="type-large mb-32 leading-default text-grey-lighter">
      This category is as empty as my fridge after a cheat day.
    </p>
    <MoreButton use={Link} to="/nutrition-explained/">
      Other stories
    </MoreButton>
  </div>
)

export default EmptyState
